import { getPunchStateForAuthUser } from '@/data/punchState/selectors/getPunchStateForAuthUser';
import useDialog from '@/dialogs/hooks/useDialog';
import ClockInLauncher from '@/punch/components/ClockInLauncher';
import { CLOCK_IN_DIALOG, PUNCH_BREAK_DIALOG } from '@/punch/dialogs';
import { Fragment } from 'react';
import { MenuItem } from '@/shared/components/nav/MenuItem';
import { useWiwSelector } from '@/store';

export default function ClockInMenu() {
  //const dispatch = useWiwDispatch();
  const dialog = useDialog();
  const punchState = useWiwSelector(getPunchStateForAuthUser);

  async function openClockInDialog(evt: Event) {
    if (evt) {
      evt.preventDefault();
    }
    dialog.open(CLOCK_IN_DIALOG);
  }

  function openBreakDialog(evt: Event) {
    if (evt) {
      evt.preventDefault();
    }
    dialog.open(PUNCH_BREAK_DIALOG);
  }

  if (!punchState) {
    return null;
  }

  const canBreak = punchState.canStartBreak || punchState.canEndBreak;
  const onBreak = punchState.canEndBreak;
  const clockedIn = !!punchState.punchStartTime;

  return (
    <Fragment>
      <ClockInLauncher key="clock-in-launcher" />
      {canBreak && (
        <MenuItem
          data-testid="take-end-break-menu-button"
          key="take-end-break"
          icon="break-unpaid-filled"
          to="#"
          onClick={(evt: Event) => openBreakDialog(evt)}
          label={onBreak ? 'End Break' : 'Take Break'}
        />
      )}
      <MenuItem
        data-testid="clock-in-out-menu-button"
        key="clock-in"
        to="#"
        onClick={(evt: Event) => openClockInDialog(evt)}
        icon="clock-in"
        label={clockedIn ? 'Clock Out' : 'Clock In'}
        disabled={onBreak}
        tooltipText={onBreak ? "You can't clock out while on break." : ''}
        tooltipClassName="clock-out-disabled-tooltip"
      />
    </Fragment>
  );
}
